function changeSort({ input, state }) {
  let sort = input.sort
  let fetchOptions = state.get('client.fetchOptions')
  if (sort === Object.keys(fetchOptions.sort)[0]) {
    let order = fetchOptions.sort[sort] === 1 ? -1 : 1
    state.set(`client.fetchOptions.sort.${sort}`, order)
  } else {
    let newSort = {}
    newSort[sort] = 1
    state.set('client.fetchOptions.sort', newSort)
  }
}

export default changeSort



// WEBPACK FOOTER //
// ./src/modules/user/actions/changeSort.js